/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Hero_NotesInputs */

const en_hero_notes = /** @type {(inputs: Hero_NotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`notes`)
};

const ar_hero_notes = /** @type {(inputs: Hero_NotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ملاحظات`)
};

const bn_hero_notes = /** @type {(inputs: Hero_NotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`নোট`)
};

const de_hero_notes = /** @type {(inputs: Hero_NotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notizen`)
};

const es_hero_notes = /** @type {(inputs: Hero_NotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`notas`)
};

const fr_hero_notes = /** @type {(inputs: Hero_NotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`articles`)
};

const pt_hero_notes = /** @type {(inputs: Hero_NotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`notas`)
};

const zh_hero_notes = /** @type {(inputs: Hero_NotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`笔记`)
};

const tr_hero_notes = /** @type {(inputs: Hero_NotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`notlar`)
};

const ru_hero_notes = /** @type {(inputs: Hero_NotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`заметки`)
};

const pl_hero_notes = /** @type {(inputs: Hero_NotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`notatki`)
};

/**
* | output |
* | --- |
* | "notes" |
*
* @param {Hero_NotesInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const hero_notes = /** @type {((inputs?: Hero_NotesInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Hero_NotesInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_hero_notes(inputs)
	if (locale === "bn") return bn_hero_notes(inputs)
	if (locale === "de") return de_hero_notes(inputs)
	if (locale === "es") return es_hero_notes(inputs)
	if (locale === "fr") return fr_hero_notes(inputs)
	if (locale === "pt") return pt_hero_notes(inputs)
	if (locale === "zh") return zh_hero_notes(inputs)
	if (locale === "tr") return tr_hero_notes(inputs)
	if (locale === "ru") return ru_hero_notes(inputs)
	if (locale === "pl") return pl_hero_notes(inputs)
	return en_hero_notes(inputs)
});